import { loadAllBookings } from './services'
import persistData from '@/lib/persist-data'

const getDefaultState = () => {
  return {
    bookings: null
  }
}

const state = getDefaultState()

const actions = {
  // load all user bookings list
  async loadAllBookingsAction ({ dispatch, commit, rootState }) {
    const token = rootState.auth.token
    const userData = rootState.auth.userData

    const data = {
      bookingNumber: userData.bookno,
      name: userData.name,
      number: userData.custno,
      system: userData.system
    }
    dispatch('spinner/updateLoadingAction', true, { root: true })
    const res = await loadAllBookings(token, data)
    if (res.error) {
      dispatch('spinner/updateLoadingAction', false, { root: true })
      dispatch('flashMessage/set', { type: 'error', message: 'Bookings not loaded. Please contact us for assistance.' }, { root: true })
      this.errorLoadingData = true
      return
    }
    if (res && res.data) {
      commit('allBookingsReceived', res.data)
      dispatch('spinner/updateLoadingAction', false, { root: true })
    }
  },
  // relogin with selected booking number and same surname
  async switchBookingAction ({ dispatch, rootState }, data) {
    const userData = rootState.auth.userData
    const newUserData = { ...userData, bookno: data.number, name: data.name  }
    dispatch('spinner/updateLoadingAction', true, { root: true })
    const initRes = await dispatch('initAppAction', newUserData, { root: true })
    persistData.setData('openedBookingNumber', data.number)
    dispatch('spinner/updateLoadingAction', false, { root: true })
    return initRes
  },
  resetStateAction ({ commit }) {
    commit('resetState')
  }
}

const mutations = {
  allBookingsReceived (state, bookings) {
    state.bookings = bookings.data.history
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
